import i18n from './i18n';
import './assets/style.css';
import App from './App.vue';
import { createApp } from 'vue';
import 'primeicons/primeicons.css';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import { registerLicense } from '@syncfusion/ej2-base';

// @ts-ignore
import Lara from '@/presets/lara';
import { setupRouter } from './router';
import { Icon } from '@iconify/vue';

import Tab from 'primevue/tab';
import Tabs from 'primevue/tabs';
import Chip from 'primevue/chip';
import Card from 'primevue/card';
import Knob from 'primevue/knob';
import Menu from 'primevue/menu';
import Badge from 'primevue/badge';
import Toast from 'primevue/toast';
import Panel from 'primevue/panel';
import Image from 'primevue/image';
import Drawer from 'primevue/drawer';
import Button from 'primevue/button';
import Column from 'primevue/column';
import Editor from 'primevue/editor';
import Avatar from 'primevue/avatar';
import Ripple from 'primevue/ripple';
import Dialog from 'primevue/dialog';
import Select from 'primevue/select';
import Message from 'primevue/message';
import Tooltip from 'primevue/tooltip';
import Toolbar from 'primevue/toolbar';
import Listbox from 'primevue/listbox';
import TabList from 'primevue/tablist';
import Divider from 'primevue/divider';
import Popover from 'primevue/popover';
import Skeleton from 'primevue/skeleton';
import TabPanel from 'primevue/tabpanel';
import Splitter from 'primevue/splitter';
import MegaMenu from 'primevue/megamenu';
import Checkbox from 'primevue/checkbox';
import Fieldset from 'primevue/fieldset';
import InputMask from 'primevue/inputmask';
import TabPanels from 'primevue/tabpanels';
import PanelMenu from 'primevue/panelmenu';
import SpeedDial from 'primevue/speeddial';
import IconField from 'primevue/iconfield';
import Paginator from 'primevue/paginator';
import InputText from 'primevue/inputtext';
import TreeTable from 'primevue/treetable';
import InputIcon from 'primevue/inputicon';
import DataTable from 'primevue/datatable';
import FileUpload from 'primevue/fileupload';
import InputGroup from 'primevue/inputgroup';
import Breadcrumb from 'primevue/breadcrumb';
import Styleclass from 'primevue/styleclass';
import AvatarGroup from 'primevue/avatargroup';
import DatePicker from 'primevue/datepicker';
import MultiSelect from 'primevue/multiselect';
import ContextMenu from 'primevue/contextmenu';
import ScrollPanel from 'primevue/scrollpanel';
import InputNumber from 'primevue/inputnumber';
import SplitButton from 'primevue/splitbutton';
import RadioButton from 'primevue/radiobutton';
import SelectButton from 'primevue/selectbutton';
import ToggleSwitch from 'primevue/toggleswitch';
import ToastService from 'primevue/toastservice';
import OverlayBadge from 'primevue/overlaybadge';
import SplitterPanel from 'primevue/splitterpanel';
import ConfirmDialog from 'primevue/confirmdialog';
import BadgeDirective from 'primevue/badgedirective';
import ProgressSpinner from 'primevue/progressspinner';
import InputGroupAddon from 'primevue/inputgroupaddon';
import VirtualScroller from 'primevue/virtualscroller';
import ConfirmationService from 'primevue/confirmationservice';
import { DocumentEditorComponent } from '@syncfusion/ej2-vue-documenteditor';
import { DocumentEditorContainerComponent } from '@syncfusion/ej2-vue-documenteditor';

const app = createApp(App);

const router = setupRouter();

registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH1cc3RRR2NfVU1+V0o=');

app.use(createPinia());
app.use(router);
app.use(ToastService);
app.use(i18n);
app.use(ConfirmationService);

app
  .component('Tab', Tab)
  .component('Chip', Chip)
  .component('Card', Card)
  .component('Tabs', Tabs)
  .component('Menu', Menu)
  .component('Knob', Knob)
  .component('Icon', Icon)
  .component('Panel', Panel)
  .component('Badge', Badge)
  .component('Toast', Toast)
  .component('Image', Image)
  .component('Column', Column)
  .component('Editor', Editor)
  .component('Button', Button)
  .component('Dialog', Dialog)
  .component('Avatar', Avatar)
  .component('Drawer', Drawer)
  .component('Select', Select)
  .component('Toolbar', Toolbar)
  .component('Divider', Divider)
  .component('Listbox', Listbox)
  .component('Message', Message)
  .component('TabList', TabList)
  .component('Popover', Popover)
  .component('Skeleton', Skeleton)
  .component('Fieldset', Fieldset)
  .component('MegaMenu', MegaMenu)
  .component('TabPanel', TabPanel)
  .component('Splitter', Splitter)
  .component('Checkbox', Checkbox)
  .component('InputMask', InputMask)
  .component('TabPanels', TabPanels)
  .component('PanelMenu', PanelMenu)
  .component('SpeedDial', SpeedDial)
  .component('IconField', IconField)
  .component('Paginator', Paginator)
  .component('DataTable', DataTable)
  .component('InputText', InputText)
  .component('InputIcon', InputIcon)
  .component('TreeTable', TreeTable)
  .component('DatePicker', DatePicker)
  .component('Breadcrumb', Breadcrumb)
  .component('InputGroup', InputGroup)
  .component('FileUpload', FileUpload)
  .component('AvatarGroup', AvatarGroup)
  .component('RadioButton', RadioButton)
  .component('InputNumber', InputNumber)
  .component('SplitButton', SplitButton)
  .component('MultiSelect', MultiSelect)
  .component('ContextMenu', ContextMenu)
  .component('ScrollPanel', ScrollPanel)
  .component('SelectButton', SelectButton)
  .component('ToggleSwitch', ToggleSwitch)
  .component('OverlayBadge', OverlayBadge)
  .component('SplitterPanel', SplitterPanel)
  .component('ConfirmDialog', ConfirmDialog)
  .component('ProgressSpinner', ProgressSpinner)
  .component('InputGroupAddon', InputGroupAddon)
  .component('VirtualScroller', VirtualScroller)
  .component('ejs-documenteditor', DocumentEditorComponent)
  .component('ejs-documenteditorcontainer', DocumentEditorContainerComponent);

app.directive('tooltip', Tooltip);
app.directive('ripple', Ripple).directive('styleclass', Styleclass).directive('badge', BadgeDirective);

app.use(PrimeVue, {
  unstyled: true,
  pt: Lara,
  ripple: true,
});

app.mount('#app');
